<ng-container *transloco="let t;">

  <div class="p-grid p-mt-6">
    <div class="p-col-8">
      <h3>{{ t('common.labels.observers') }}</h3>
    </div>
    <div class="p-col-4 p-text-right" *ngIf="inEdit === true">
      <button *ngIf="canEditObservers() === true" (click)="editObserver()" pButton type="button" [label]="t('common.labels.add')" icon="pi pi-plus" class="p-button-secondary p-button-sm p-button-outlined" [disabled]="(submitting === true) ? true : null"></button>
    </div>
  </div>

  <p-table [value]="acObservers">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="lastname">{{ t('common.labels.lastname') }}
            <p-sortIcon field="lastname"></p-sortIcon>
        </th>
        <th pSortableColumn="firstname">{{ t('common.labels.firstname') }}
            <p-sortIcon field="firstname"></p-sortIcon>
        </th>
        <th pSortableColumn="mobile">{{ t('common.labels.mobile') }}
            <p-sortIcon field="mobile"></p-sortIcon>
        </th>
        <th pSortableColumn="email">{{ t('common.labels.email') }}
            <p-sortIcon field="email"></p-sortIcon>
        </th>
        <th><fa-icon [icon]="faCommentSlash" [pTooltip]="t('common.labels.is_silent_observer')"></fa-icon></th>
        <th *ngIf="inEdit !== true && canResendEmail() === true"></th>
        <th *ngIf="inEdit === true && canEditObservers() === true"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-observer>
        <tr>
          <td>{{ observer.lastname }}</td>
          <td>{{ observer.firstname }}</td>
          <td>{{ observer.mobile }}</td>
          <td>
            {{ observer.email }}
            <span *ngIf="observer.invited_at" class="p-text-small"><br/>{{ t('common.labels.invitation_sended_at') }} {{ observer.invited_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }} {{ t('common.labels.oclock') }}</span>
          </td>
          <td><fa-icon *ngIf="observer.silentobserver === true" [icon]="faCommentSlash" [pTooltip]="t('common.labels.is_silent_observer')"></fa-icon></td>
          <td class="p-text-right" *ngIf="inEdit !== true && canResendEmail() === true">
            <button pButton type="button" (click)="onResendInvitation(observer)" icon="pi pi-envelope" [pTooltip]="t('ac_persons.resend_invitation')" tooltipPosition="left" class="p-button-outlined p-ml-2"></button>
          </td>
          <td class="p-text-right" *ngIf="inEdit === true && canEditObservers() === true">
            <button pButton (click)="editObserver(observer)" type="button" icon="pi pi-pencil" class="p-button-outlined p-mr-2" [disabled]="(submitting === true) ? true : null"></button>
            <button pButton (click)="deleteObserver(observer)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button" [disabled]="(submitting === true) ? true : null"></button>
          </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="no-data" colspan="8">{{ t('common.labels.no_data') }}</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog [header]="t('common.labels.add_observer')" [(visible)]="dialogVisible" [style]="{width: '360px'}" [draggable]="false" [modal]="true">
    <form (submit)="saveObserver()">
      <app-form-control [cid]="'observer'" [control]="participantForm.get('observer')" [type]="'select'" [options]="optionsObservers" optionLabel="fullname_reverse" [filter]="true" [label]="t('common.labels.observer')"></app-form-control>
      <app-form-control [cid]="'silentobserver'" [control]="participantForm.get('silentobserver')" [type]="'checkbox'" [label]="t('common.labels.is_silent_observer')"></app-form-control>
      <p-footer>
        <div class="p-text-right">
          <button pButton (click)="cancelObserver()" type="button" label="{{ t('common.labels.cancel') }}" class="p-button-outlined p-button-secondary p-mr-2"></button>
          <button pButton type="submit" label="{{ t('common.ok') }}" class="p-button-success"></button>
        </div>
      </p-footer>
    </form>
  </p-dialog>

</ng-container>
